<template>
    <div class="page_box">
        <div class="page_content">
            <div class="page_list" v-for="(item, index) in addressListData" :key="item.id"
                :class="{ 'active': selectedIndex === index }" @click="selectAddress(index)">
                <div class="page_item" style="width:89%;">
                    <span>{{ item.province }}{{item.city}}{{ item.district }}</span>
                    <span>{{ item.address }}</span>
                    <span>{{ item.name }} {{ item.phone }}</span>
                </div>
                <div class="page_edit" @click="editAddressList(item, index, $event)">
                    <a>编辑</a>
                </div>
            </div>
        </div>
        <div class="add_address" @click="submit()">确定</div>
        <div class="add_address_but" @click="showAddDialog">+</div>
        <!-- 新增/编辑地址弹框 -->
        <van-popup v-model="showDialog" position="bottom" :style="{ height: '70%' }" round closeable
            close-icon-position="top-right">
            <div class="dialog_container">
                <div class="dialog_header">
                    <h3>{{ isEdit ? '编辑地址' : '新增地址' }}</h3>
                </div>
                <div class="dialog_body">
                    <van-field v-model="addressForm.name" label="收货人姓名" placeholder="请输入收货人姓名" required
                        :error-message="nameError" />

                    <van-field v-model="addressForm.phone" type="tel" label="手机号码" placeholder="请输入手机号码" required
                        :error-message="phoneError" />

                    <van-field v-model="regionDisplayText" label="所在地区" placeholder="请选择省市区" @click="selectRegion"
                        readonly required :error-message="regionError" right-icon="arrow" />

                    <van-field v-model="addressForm.address" type="textarea" label="详细地址" placeholder="请输入详细地址" rows="3"
                        autosize required :error-message="addressError" />
                </div>

                <div class="dialog_footer">
                    <van-button size="large" @click="hideDialog" style="margin-right: 12px;">
                        取消
                    </van-button>
                    <van-button type="primary" size="large" @click="saveAddress" color="#17C2CF">
                        保存
                    </van-button>
                </div>
            </div>
        </van-popup>

        <!-- 地区选择弹框 -->
        <van-popup v-model="showAreaPicker" position="bottom" round>
            <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showAreaPicker = false" title="选择地区" />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { areaList } from '@vant/area-data'
import { addAddress, getAddAddressList, editAddress, redeemNow } from '@/services/common.js'
export default {
    data() {
        return {
            selectedIndex: null,
            showDialog: false,
            showAreaPicker: false,
            isEdit: false,
            areaList,
            addressForm: {
                name: '',
                phone: '',
                address: '',
                province: '',
                district: '',
                city: ''
            },
            // 错误信息
            nameError: '',
            phoneError: '',
            regionError: '',
            addressError: '',
            addressListData: [],
            editList: 0,
            listItemid: 0,
            selectedAddressId:null,
        }
    },
    computed: {
        // 用于显示的地区文本
        regionDisplayText() {
            if (this.addressForm.province && this.addressForm.city && this.addressForm.district) {
                return `${this.addressForm.province} ${this.addressForm.city} ${this.addressForm.district}`
            }
            return ''
        }
    },
    created() {
        this.list();
        this.listItemid = this.$route.query.id;
        this.selectedAddressId = this.$route.query.selectedAddressId;
    },
    methods: {
        list() {
            const params = {
                current: 1,
                size: 999
            }
            getAddAddressList(params).then((res) => {
                this.addressListData = res.data.records;
                this.setDefaultSelectedAddress();
            })
        },
        // 选中的地址是那个;
        setDefaultSelectedAddress() {
        if (this.selectedAddressId) {
            // 查找匹配的地址索引
            const index = this.addressListData.findIndex(address =>
                address.id === this.selectedAddressId
            );
            if (index !== -1) {
                this.selectedIndex = index;
            }
        }
    },
        submit() {
            // // 检查是否选择了地址
            if (this.selectedIndex === null) {
                Toast('请选择一个地址');
                return;
            }
            // // 获取选中的地址数据
            const selectedAddress = this.addressListData[this.selectedIndex];
            const params = {
                activitySendId: this.listItemid,
                userAddressId: selectedAddress.id
            }
            redeemNow(params).then((res) => {
                if (res.result === true) {
                    Toast('兑换成功');
                    this.$router.replace({
                        path: '/collectionRecord'
                    })
                } else {
                    Toast('兑换失败');
                }
            })
        },
        editAddressList(item, index, event) {
            this.isEdit = true;
            this.editIndex = index;
            this.editList = item.id;
            // 修复地区赋值逻辑
            this.addressForm = {
                name: item.name,
                phone: item.phone,
                address: item.address,
                // 直接使用后端返回的字段，如果字段名不同请根据实际情况调整
                province: item.province,
                city: item.city,
                district: item.district
            };

            this.clearErrors();
            this.showDialog = true;
        },
        selectAddress(index) {
            this.selectedIndex = index;
        },
        showAddDialog() {
            this.isEdit = false;
            this.resetForm();
            this.clearErrors();
            this.showDialog = true;
        },
        hideDialog() {
            this.showDialog = false;
            this.clearErrors();
        },
        resetForm() {
            this.addressForm = {
                name: '',
                phone: '',
                address: '',
                province: '',
                district: '',
                city: ''
            };
        },
        clearErrors() {
            this.nameError = '';
            this.phoneError = '';
            this.regionError = '';
            this.addressError = '';
        },
        selectRegion() {
            this.showAreaPicker = true;
        },
        onAreaConfirm(values) {
            const [province, city, county] = values;
            this.addressForm.province = province.name;
            this.addressForm.city = city.name;
            this.addressForm.district = county.name;
            this.showAreaPicker = false;
            this.regionError = '';
        },
        saveAddress() {
            // 清除之前的错误信息
            this.clearErrors();

            // 表单验证
            let hasError = false;

            if (!this.addressForm.name.trim()) {
                this.nameError = '请输入收货人姓名';
                hasError = true;
            }

            if (!this.addressForm.phone.trim()) {
                this.phoneError = '请输入手机号码';
                hasError = true;
            } else if (!/^1[3-9]\d{9}$/.test(this.addressForm.phone)) {
                this.phoneError = '请输入正确的手机号码';
                hasError = true;
            }

            if (!this.addressForm.province || !this.addressForm.city || !this.addressForm.district) {
                this.regionError = '请选择所在地区';
                hasError = true;
            }

            if (!this.addressForm.address.trim()) {
                this.addressError = '请输入详细地址';
                hasError = true;
            }

            if (hasError) {
                return;
            }
            const params = {
                type: 1,
                defaultFlag: 0,
                name: this.addressForm.name,
                phone: this.addressForm.phone,
                address: this.addressForm.address,
                province: this.addressForm.province,
                city: this.addressForm.city,
                district: this.addressForm.district,
            }
            if (this.editList) {
                editAddress(this.editList, params).then((res) => {
                    this.list();
                })
            } else {
                addAddress(params).then((res) => {
                    this.list();
                })
            }
            editAddress(this.editList, params).then((res) => {

            })
            Toast.success('保存成功');
            this.hideDialog();
        }
    }
}
</script>

<style lang="less" scoped>
.page_box {
    height: 99vh;
    background: #F7F8FC;
    padding: 10px;
}

.page_content {
    height: 90vh;
    overflow-y: scroll;
    margin-bottom: 6px;
}

.page_list {
    background-color: #ffffff;
    margin: 10px auto;
    border-radius: 8px;
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: #f0f0f0;
    }

    &.active {
        background-color: #e6f7ff;
        color: #17C2CF;
    }
}

.page_item {
    display: flex;
    flex-direction: column;
}

.add_address {
    background-color: #17C2CF;
    color: #ffffff;
    margin: 0 auto;
    width: 240px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    cursor: pointer;

    &:hover {
        background-color: #15a8b5;
    }
}

.add_address_but {
    position: fixed;
    right: 10px;
    bottom: 150px;
    font-size: 36px;
    font-weight: 500;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #15a8b5;
    color: #ffffff;
}

// Vant弹框样式定制
.dialog_container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.dialog_header {
    padding: 20px 16px 10px;
    text-align: center;
    border-bottom: 1px solid #ebedf0;

    h3 {
        margin: 0;
        font-size: 18px;
        color: #323233;
        font-weight: 500;
    }
}

.dialog_body {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
}

.dialog_footer {
    padding: 16px;
    display: flex;
    gap: 12px;

    .van-button {
        flex: 1;
    }
}

// 自定义van-field样式
:deep(.van-field__label) {
    color: #323233;
    font-weight: 500;
}

:deep(.van-field__control) {
    color: #323233;
}

:deep(.van-field__error-message) {
    color: #ee0a24;
}
</style>
